import { default as MuiTableCell } from '@mui/material/TableCell';

/**
 * TableCell represents a single cell within a Table row.
 *
 * Demos:
 *
 * - [Table](https://unify.workiva.org/components/table?tab=code)
 *
 * API:
 *
 * - [TableCell API](https://unify.workiva.org/components/table?tab=props#tablecell)
 */
export const TableCell = MuiTableCell;
export { type TableCellProps, tableCellClasses } from '@mui/material/TableCell';
